import React from "react";
import { SectionHeader } from "../../../common/WorkspaceChrome";
import { WorkBoard } from "../../tasks-tickets/WorkBoard";

export function MyActivityTab({ activityRows }) {
  return (
    <section className="panel">
      <SectionHeader
        eyebrow="My Activity"
        title="Everything the logged-in user needs today"
        text="A personal cockpit for assigned work, meetings, attendance, leave, docs, and wallet activity."
      />
      <div className="dashboard-detail-grid">
        {activityRows.map((item) => (
          <article key={item.label}>
            <span>{item.label}</span>
            <strong>{item.value}</strong>
            <p>{item.detail}</p>
          </article>
        ))}
      </div>
      <WorkBoard workView="List" setWorkView={() => {}} />
    </section>
  );
}
